
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      const context = page.route.context;
      var totalOpd = parseInt(context.data.subscriptions.total_opd) || 0;
      var usedOpd = parseInt(context.data.subscriptions.used_opd) || 0;
      if (totalOpd > 0) {
        var percent = Math.round(usedOpd / totalOpd * 100);
        if (percent > 100)
          percent = 100;
        setTimeout(function () {
          $$('#opdProgressFill').css('width', percent + '%');
        }, 200);
        $$('#opdProgressText').text(usedOpd + ' of ' + totalOpd + ' OPD visits used (' + percent + '%)');
      } else {
        $$('#opdProgressText').text('No OPD visits included');
      }
      $$('#sdTncToggle').on('click', function () {
        $$('#sdTncBody').toggleClass('sd-tnc-expanded');
        $$('#sdTncArrow').toggleClass('sd-tnc-open');
      });
      var currentPatientIds = [];
      if (context.data.patientlist && context.data.patientlist.length) {
        context.data.patientlist.forEach(function (p) {
          currentPatientIds.push(String(p.id));
        });
      }
      var currentPackageId = context.data.package ? context.data.package.id : null;
      $$('#renewBtn').on('click', function () {
        if (currentPatientIds.length > 0) {
          localStorage.setItem('renew_patient_ids', JSON.stringify(currentPatientIds));
        }
        if (currentPackageId) {
          app.views.main.router.navigate('/subscription-booking/' + currentPackageId + '/');
        } else {
          app.preloader.show();
          app.methods.authHeader();
          var url = app.data.remoteUrl + 'subscription-plans';
          app.request.json(url, function (data) {
            app.preloader.hide();
            if (data.status) {
              var plans = data.data || data.plans || [];
              var plansHtml = '<ul>';
              plans.forEach(function (plan) {
                var icon = plan.type == 0 ? 'person' : 'group';
                plansHtml += '<li>' + '<label class="item-radio item-content">' + '<input type="radio" name="plan" value="' + plan.id + '">' + '<i class="icon icon-radio"></i>' + '<div class="item-inner">' + '<div class="item-title-row">' + '<div class="item-title">' + '<i class="material-icons">' + icon + '</i> ' + plan.name + '</div>' + '<div class="item-after">Rs. ' + plan.amount + '</div>' + '</div>' + '<div class="item-subtitle">' + (plan.description || '') + '</div>' + '</div>' + '</label>' + '</li>';
              });
              plansHtml += '</ul>';
              plansHtml += '<div class="block"><button class="button button-fill button-large" id="proceedRenewBtn" style="background: var(--mdoc-green); border-radius: 100px; box-shadow: 0 4px 14px rgba(46, 182, 125, 0.25);">Renew</button></div>';
              $$('#subscriptionPlansList').html(plansHtml);
              app.popup.open('#renewSubscriptionPopup');
              $$('#proceedRenewBtn').on('click', function () {
                var selectedPlan = $$('input[name="plan"]:checked').val();
                if (!selectedPlan) {
                  app.dialog.alert('Please select a plan');
                  return;
                }
                app.popup.close('#renewSubscriptionPopup');
                app.views.main.router.navigate('/subscription-booking/' + selectedPlan + '/');
              });
            } else {
              app.dialog.alert(data.msg || 'Failed to load plans');
            }
          });
        }
      });
    }
  },
  id: '2a9be391ea',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" data-name="subscription-details" id="subscriptionDetailsPage">\r\n        <div class="navbar">\r\n            <div class="navbar-inner sliding">\r\n                <div class="left">\r\n                    <a href="#" class="link back">\r\n                        <i class="icon icon-back"></i>\r\n                    </a>\r\n                </div>\r\n                <div class="title">Subscription Details</div>\r\n            </div>\r\n        </div>\r\n        <div class="page-content">\r\n\r\n            <!-- Package Header Card -->\r\n            <div class="card sd-plan-card">\r\n                <div class="sd-plan-header">\r\n                    <div class="sd-plan-icon">\r\n                        <i class="material-icons">';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.package.type == 1', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'group';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'person';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\r\n                    </div>\r\n                    <div class="sd-plan-title">\r\n                        <p class="sd-plan-name">';
      r += c(ctx_1.data.package.name, ctx_1);
      r += '</p>\r\n                    </div>\r\n                    <div class="sd-status-badge ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.subscriptions.status, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'sd-active';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'sd-expired';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '">\r\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.subscriptions.status, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'Active';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'Expired';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Plan Terms & Conditions -->\r\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.package.description, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="card sd-info-card">\r\n                <div class="sd-tnc-header" id="sdTncToggle">\r\n                    <div class="sd-section-title" style="margin-bottom: 0;">\r\n                        <i class="material-icons">description</i>\r\n                        <span>Terms & Conditions</span>\r\n                    </div>\r\n                    <i class="material-icons sd-tnc-arrow" id="sdTncArrow">keyboard_arrow_down</i>\r\n                </div>\r\n                <div class="sd-tnc-body" id="sdTncBody">\r\n                    <p class="sd-tnc-text">';
          r += c(ctx_2.data.package.description, ctx_2);
          r += '</p>\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Validity Card -->\r\n            <div class="card sd-info-card">\r\n                <div class="sd-section-title">\r\n                    <i class="material-icons">event_note</i>\r\n                    <span>Validity Period</span>\r\n                </div>\r\n                <div class="sd-validity-row">\r\n                    <div class="sd-validity-item">\r\n                        <span class="sd-validity-label">From</span>\r\n                        <span class="sd-validity-value">';
      r += c(ctx_1.data.subscriptions.valid_from, ctx_1);
      r += '</span>\r\n                    </div>\r\n                    <div class="sd-validity-divider">\r\n                        <i class="material-icons">arrow_forward</i>\r\n                    </div>\r\n                    <div class="sd-validity-item">\r\n                        <span class="sd-validity-label">Upto</span>\r\n                        <span class="sd-validity-value">';
      r += c(ctx_1.data.subscriptions.valid_upto, ctx_1);
      r += '</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <!-- OPD Usage Card -->\r\n            <div class="card sd-info-card">\r\n                <div class="sd-section-title">\r\n                    <i class="material-icons">local_hospital</i>\r\n                    <span>OPD Usage</span>\r\n                </div>\r\n                <div class="sd-opd-stats">\r\n                    <div class="sd-opd-stat">\r\n                        <div class="sd-opd-circle sd-opd-total">\r\n                            <span class="sd-opd-number">';
      r += c(ctx_1.data.subscriptions.total_opd, ctx_1);
      r += '</span>\r\n                        </div>\r\n                        <span class="sd-opd-label">Total</span>\r\n                    </div>\r\n                    <div class="sd-opd-stat">\r\n                        <div class="sd-opd-circle sd-opd-used">\r\n                            <span class="sd-opd-number">';
      r += c(ctx_1.data.subscriptions.used_opd, ctx_1);
      r += '</span>\r\n                        </div>\r\n                        <span class="sd-opd-label">Used</span>\r\n                    </div>\r\n                    <div class="sd-opd-stat">\r\n                        <div class="sd-opd-circle sd-opd-balance">\r\n                            <span class="sd-opd-number">';
      r += c(ctx_1.data.subscriptions.unused_opd, ctx_1);
      r += '</span>\r\n                        </div>\r\n                        <span class="sd-opd-label">Balance</span>\r\n                    </div>\r\n                </div>\r\n                <!-- Progress Bar -->\r\n                <div class="sd-opd-progress-wrap">\r\n                    <div class="sd-opd-progress-bar">\r\n                        <div class="sd-opd-progress-fill" id="opdProgressFill"></div>\r\n                    </div>\r\n                    <p class="sd-opd-progress-text" id="opdProgressText"></p>\r\n                </div>\r\n            </div>\r\n\r\n            <!-- Patients Card -->\r\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.patientlist.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="card sd-info-card">\r\n                <div class="sd-section-title">\r\n                    <i class="material-icons">people</i>\r\n                    <span>Covered Patients</span>\r\n                    <span class="sd-patient-count">';
          r += c(ctx_2.data.patientlist.length, ctx_2);
          r += '</span>\r\n                </div>\r\n                <div class="sd-patient-list">\r\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data.patientlist, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                    <div class="sd-patient-item">\r\n                        <div class="sd-patient-avatar ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.gender === \'Female\'', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'sd-avatar-female';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '">\r\n                            <span class="sd-avatar-initial">';
              r += Template7Helpers.js_if.call(ctx_3, 'this.name', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '</span>\r\n                        </div>\r\n                        <div class="sd-patient-info">\r\n                            <p class="sd-patient-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</p>\r\n                            <p class="sd-patient-meta">';
              r += c(ctx_3.gender, ctx_3);
              r += ' &middot; ';
              r += c(ctx_3.age, ctx_3);
              r += ' yrs</p>\r\n                        </div>\r\n                    </div>\r\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                </div>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n            <!-- Appointments under this subscription -->\r\n            <div class="card sd-info-card">\r\n                <div class="sd-section-title">\r\n                    <i class="material-icons">event_available</i>\r\n                    <span>Appointments</span>\r\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.appointments.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                    <span class="sd-patient-count">';
          r += c(ctx_2.data.appointments.length, ctx_2);
          r += '</span>\r\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n                </div>\r\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.appointments.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                <div class="sd-appt-list">\r\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data.appointments, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n                    <a href="/appointmentDetails/';
              r += c(ctx_3.id, ctx_3);
              r += '/" class="sd-appt-item link">\r\n                        <div class="sd-appt-date">\r\n                            <div class="sd-appt-date-day">';
              r += c(ctx_3.day, ctx_3);
              r += '</div>\r\n                            <div class="sd-appt-date-num">';
              r += c(ctx_3.date, ctx_3);
              r += '</div>\r\n                            <div class="sd-appt-date-mon">';
              r += c(ctx_3.month, ctx_3);
              r += '</div>\r\n                        </div>\r\n                        <div class="sd-appt-info">\r\n                            <p class="sd-appt-doctor">Dr. ';
              r += c(ctx_3.doctor_name, ctx_3);
              r += '</p>\r\n                            ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.department_name, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\r\n                            <p class="sd-appt-meta">';
                  r += c(ctx_4.department_name, ctx_4);
                  r += '</p>\r\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                            <p class="sd-appt-meta">\r\n                                ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.patient_name, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += c(ctx_4.patient_name, ctx_4);
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                                ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.time, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' &middot; ';
                  r += c(ctx_4.time, ctx_4);
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\r\n                            </p>\r\n                        </div>\r\n                        <i class="material-icons sd-appt-arrow">chevron_right</i>\r\n                    </a>\r\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                </div>\r\n                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n                <p class="sd-appt-empty">No appointments booked under this subscription yet.</p>\r\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n            </div>\r\n\r\n            <!-- Renew Button -->\r\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.data.subscriptions.status, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="block" style="margin-top: 20px;">\r\n                <button class="button sd-renew-btn" id="renewBtn">\r\n                    <i class="material-icons">autorenew</i>\r\n                    <span>Renew Subscription</span>\r\n                </button>\r\n            </div>\r\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n\r\n        </div>\r\n\r\n        <!-- Subscription Plans Popup -->\r\n        <div class="popup" id="renewSubscriptionPopup">\r\n            <div class="view">\r\n                <div class="page">\r\n                    <div class="navbar">\r\n                        <div class="navbar-inner">\r\n                            <div class="left">\r\n                                <a href="#" class="link popup-close" aria-label="Close">\r\n                                    <i class="icon icon-back"></i>\r\n                                </a>\r\n                            </div>\r\n                            <div class="title">Choose a Plan</div>\r\n                        </div>\r\n                    </div>\r\n                    <div class="page-content">\r\n                        <div class="block-title">Select Subscription Plan</div>\r\n                        <div class="list" id="subscriptionPlansList">\r\n                            <!-- Plans will be loaded dynamically -->\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  style: `
[data-f7-2a9be391ea] .page-content { background: var(--mdoc-bg); padding-bottom: 24px; }

    /* Plan Header Card — pastel gradient (matches home plan cards) */
[data-f7-2a9be391ea] .sd-plan-card {
        margin: 14px 14px 12px;
        border-radius: 18px;
        overflow: hidden;
        background: linear-gradient(160deg, var(--mdoc-green-soft) 0%, var(--mdoc-blue-soft) 100%);
        border: 1px solid rgba(46, 182, 125, 0.18);
        position: relative;
        box-shadow: none;
        padding: 0;
    }
[data-f7-2a9be391ea] .sd-plan-card::after {
        content: "";
        position: absolute;
        top: -30px;
        right: -30px;
        width: 130px;
        height: 130px;
        background: radial-gradient(circle, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 70%);
        border-radius: 50%;
        pointer-events: none;
    }
[data-f7-2a9be391ea] .sd-plan-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 18px 16px;
        position: relative;
        z-index: 1;
    }
[data-f7-2a9be391ea] .sd-plan-icon {
        width: 48px;
        height: 48px;
        border-radius: 14px;
        background: var(--mdoc-white);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(15, 31, 46, 0.08);
    }
[data-f7-2a9be391ea] .sd-plan-icon i {
        font-size: 24px;
        color: var(--mdoc-green-dark);
    }
[data-f7-2a9be391ea] .sd-plan-title {
        flex: 1;
        min-width: 0;
    }
[data-f7-2a9be391ea] .sd-plan-name {
        font-size: 17px;
        font-weight: 800;
        color: var(--mdoc-ink);
        letter-spacing: -0.2px;
        margin: 0;
        line-height: 1.2;
    }
[data-f7-2a9be391ea] .sd-status-badge {
        padding: 3px 10px;
        border-radius: 100px;
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        flex-shrink: 0;
    }
[data-f7-2a9be391ea] .sd-status-badge.sd-active {
        background: var(--mdoc-green);
        color: var(--mdoc-white);
    }
[data-f7-2a9be391ea] .sd-status-badge.sd-expired {
        background: #FFF1E0;
        color: #C2570A;
    }

    /* Info Cards */
[data-f7-2a9be391ea] .sd-info-card {
        margin: 12px 14px;
        border-radius: 14px;
        padding: 14px 16px;
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        box-shadow: none;
    }
[data-f7-2a9be391ea] .sd-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-size: 11.5px;
        font-weight: 700;
        color: var(--mdoc-muted);
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
[data-f7-2a9be391ea] .sd-section-title i {
        font-size: 18px;
        color: var(--mdoc-green-dark);
    }

    /* Terms & Conditions */
[data-f7-2a9be391ea] .sd-tnc-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 0 !important;
    }
[data-f7-2a9be391ea] .sd-tnc-arrow {
        font-size: 22px;
        color: var(--mdoc-muted);
        transition: transform 0.3s ease;
    }
[data-f7-2a9be391ea] .sd-tnc-arrow.sd-tnc-open { transform: rotate(180deg); }
[data-f7-2a9be391ea] .sd-tnc-body {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
    }
[data-f7-2a9be391ea] .sd-tnc-body.sd-tnc-expanded { max-height: 600px; }
[data-f7-2a9be391ea] .sd-tnc-text {
        font-size: 12.5px;
        color: var(--mdoc-ink);
        line-height: 1.55;
        margin: 12px 0 0;
        padding: 12px;
        background: var(--mdoc-bg);
        border-radius: 10px;
        border-left: 3px solid var(--mdoc-green);
    }

    /* Validity */
[data-f7-2a9be391ea] .sd-validity-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(135deg, var(--mdoc-green-soft) 0%, var(--mdoc-blue-soft) 100%);
        border-radius: 12px;
        padding: 14px 12px;
        border: 1px solid rgba(46, 182, 125, 0.18);
    }
[data-f7-2a9be391ea] .sd-validity-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        flex: 1;
        min-width: 0;
    }
[data-f7-2a9be391ea] .sd-validity-label {
        font-size: 10px;
        color: var(--mdoc-muted);
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.5px;
    }
[data-f7-2a9be391ea] .sd-validity-value {
        font-size: 13.5px;
        font-weight: 700;
        color: var(--mdoc-ink);
        text-align: center;
    }
[data-f7-2a9be391ea] .sd-validity-divider {
        flex-shrink: 0;
        padding: 0 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
[data-f7-2a9be391ea] .sd-validity-divider i {
        font-size: 16px;
        color: var(--mdoc-green-dark);
    }

    /* OPD Stats */
[data-f7-2a9be391ea] .sd-opd-stats {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 10px;
        margin-bottom: 14px;
    }
[data-f7-2a9be391ea] .sd-opd-stat {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
    }
[data-f7-2a9be391ea] .sd-opd-circle {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid;
    }
[data-f7-2a9be391ea] .sd-opd-circle.sd-opd-total {
        border-color: var(--mdoc-blue);
        background: var(--mdoc-blue-soft);
    }
[data-f7-2a9be391ea] .sd-opd-circle.sd-opd-used {
        border-color: #E0573A;
        background: #FFF1E0;
    }
[data-f7-2a9be391ea] .sd-opd-circle.sd-opd-balance {
        border-color: var(--mdoc-green);
        background: var(--mdoc-green-soft);
    }
[data-f7-2a9be391ea] .sd-opd-number {
        font-size: 20px;
        font-weight: 800;
        color: var(--mdoc-ink);
        letter-spacing: -0.4px;
    }
[data-f7-2a9be391ea] .sd-opd-label {
        font-size: 11px;
        color: var(--mdoc-muted);
        font-weight: 600;
    }

    /* Progress Bar */
[data-f7-2a9be391ea] .sd-opd-progress-wrap {
        padding: 0 4px;
    }
[data-f7-2a9be391ea] .sd-opd-progress-bar {
        height: 8px;
        background: var(--mdoc-bg);
        border-radius: 100px;
        overflow: hidden;
        border: 1px solid var(--mdoc-border);
    }
[data-f7-2a9be391ea] .sd-opd-progress-fill {
        height: 100%;
        background: linear-gradient(90deg, var(--mdoc-green) 0%, var(--mdoc-blue) 100%);
        border-radius: 100px;
        transition: width 0.6s ease;
        width: 0%;
    }
[data-f7-2a9be391ea] .sd-opd-progress-text {
        font-size: 11.5px;
        color: var(--mdoc-muted);
        text-align: center;
        margin-top: 8px;
        font-weight: 600;
    }

    /* Patients */
[data-f7-2a9be391ea] .sd-patient-count {
        margin-left: auto;
        background: var(--mdoc-green-soft);
        color: var(--mdoc-green-dark);
        min-width: 22px;
        height: 22px;
        padding: 0 8px;
        border-radius: 100px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 11.5px;
        font-weight: 800;
    }
[data-f7-2a9be391ea] .sd-patient-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
[data-f7-2a9be391ea] .sd-patient-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 12px;
        background: var(--mdoc-bg);
        border-radius: 12px;
    }
[data-f7-2a9be391ea] .sd-patient-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(135deg, var(--mdoc-green) 0%, var(--mdoc-green-dark) 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
[data-f7-2a9be391ea] .sd-patient-avatar.sd-avatar-female {
        background: linear-gradient(135deg, var(--mdoc-blue) 0%, var(--mdoc-blue-dark) 100%);
    }
[data-f7-2a9be391ea] .sd-avatar-initial {
        font-size: 16px;
        font-weight: 700;
        color: var(--mdoc-white);
    }
[data-f7-2a9be391ea] .sd-patient-info { flex: 1; min-width: 0; }
[data-f7-2a9be391ea] .sd-patient-name {
        font-size: 14px;
        font-weight: 700;
        color: var(--mdoc-ink);
        margin: 0;
        line-height: 1.2;
    }
[data-f7-2a9be391ea] .sd-patient-meta {
        font-size: 12px;
        color: var(--mdoc-muted);
        margin: 3px 0 0;
    }

    /* Appointments */
[data-f7-2a9be391ea] .sd-appt-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
[data-f7-2a9be391ea] .sd-appt-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 12px;
        background: var(--mdoc-bg);
        border-radius: 12px;
        color: inherit;
        text-decoration: none;
    }
[data-f7-2a9be391ea] .sd-appt-item:active { background: #eef2f6; }
[data-f7-2a9be391ea] .sd-appt-date {
        flex-shrink: 0;
        width: 52px;
        padding: 6px 0;
        border-radius: 10px;
        background: var(--mdoc-white);
        border: 1px solid var(--mdoc-border);
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
[data-f7-2a9be391ea] .sd-appt-date-day {
        font-size: 10px;
        font-weight: 700;
        color: var(--mdoc-muted);
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }
[data-f7-2a9be391ea] .sd-appt-date-num {
        font-size: 18px;
        font-weight: 800;
        color: var(--mdoc-ink);
        line-height: 1;
    }
[data-f7-2a9be391ea] .sd-appt-date-mon {
        font-size: 10px;
        font-weight: 700;
        color: var(--mdoc-green-dark);
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }
[data-f7-2a9be391ea] .sd-appt-info { flex: 1; min-width: 0; }
[data-f7-2a9be391ea] .sd-appt-doctor {
        margin: 0;
        font-size: 14px;
        font-weight: 700;
        color: var(--mdoc-ink);
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-2a9be391ea] .sd-appt-meta {
        margin: 3px 0 0;
        font-size: 12px;
        color: var(--mdoc-muted);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
[data-f7-2a9be391ea] .sd-appt-arrow {
        font-size: 20px;
        color: var(--mdoc-muted);
        flex-shrink: 0;
    }
[data-f7-2a9be391ea] .sd-appt-empty {
        margin: 4px 0 0;
        padding: 12px;
        font-size: 12.5px;
        color: var(--mdoc-muted);
        text-align: center;
        background: var(--mdoc-bg);
        border-radius: 10px;
    }

    /* Renew Button */
[data-f7-2a9be391ea] .sd-renew-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: var(--mdoc-green);
        color: var(--mdoc-white);
        border: none;
        border-radius: 100px;
        padding: 14px 18px;
        font-size: 15px;
        font-weight: 700;
        width: 100%;
        box-shadow: 0 4px 14px rgba(46, 182, 125, 0.25);
    }
[data-f7-2a9be391ea] .sd-renew-btn:active { background: var(--mdoc-green-dark); }
[data-f7-2a9be391ea] .sd-renew-btn i {
        font-size: 20px;
        color: var(--mdoc-white);
    }
`,
  styleScoped: true
};
    